import axios from "axios";
import {apiConfig} from "@/config";

export default class DepService {
    static async doiOne() {

    }

    static async getHyveSubscriptions(msisdn) {
        const response = await axios.get(`${apiConfig.hyveService}/get-user-subscriptions`, {
            params: {msisdn},
        })

        return response?.data;
    }

    static async encryptMsisdn(msisdn) {
        const response = await axios.post(`${apiConfig.depService}/encrypt-msisdn/v2`, {
                msisdn,
            },
        )

        return response?.data?.['e-msisdn'];
    }

    static async validateMyBundleEntry(productId, rawQueryString) {
        const response = await axios.post(`${apiConfig.depService}/my-bundle/validate-entry`, {
                productId,
                rawQueryString,
            },
        )

        return response.data;
    }
}
